import React, { useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import FileUploaderMC from '../../../components/FileUploaderMC';
import TitleMC from '../../../components/TitleMC';
import DropdownInputMC from '../../../components/DropdownInputMC';

const Step2QrPartial = () => {
  const { t } = useTranslation('createCampaign');
  const [messageValues, setMessageValues] = useState({});

  const { current_retailer } = useSelector(
    (reduxState) => reduxState.createCampaignReducer
  );

  const containerRef = useRef(null);

  const customer_columns_list = current_retailer?.catalogs?.customer_columns_list?.map(([name, value]) => ({
    name,
    value: `{{${value}}}`
  })) || [];

  const onChangeHandler = (value, key, field) => {
    const updatedMessageValues = { ...messageValues, [key]: value };
    setMessageValues(updatedMessageValues);
    field.onChange(updatedMessageValues);
    trigger('message_values');
  };

  const {
    control, formState: { errors }, trigger, getValues
  } = useFormContext();

  return (
    <div className="tw-wrapper">
      <div id="step-2">
        <TitleMC text={t('step2QR.title')} variant="BASE" />
        <div className="tw-text-body tw-pb-6">
          <p dangerouslySetInnerHTML={{
            __html: t('step2QR.description', { character: '<span class="tw-font-bold tw-italic">@</span>' })
          }}
          />
        </div>
        <Controller
          name="message_values"
          control={control}
          render={({ field, formState }) => (
            <div ref={containerRef}>
              <div className="tw-py-2">
                <DropdownInputMC
                  isTextArea
                  rows={5}
                  options={customer_columns_list}
                  fullWidth
                  className="tw-w-full"
                  name="template_text"
                  defaultValue={getValues('message_values.template_text')}
                  onSelect={(value) => {
                    onChangeHandler(value, 'template_text', field);
                  }}
                />
              </div>
              <div className="tw-py-2">
                <FileUploaderMC
                  name="campaign-file"
                  label={t('step2QR.fileLabel')}
                  id="campaign-file"
                  acceptedFileTypes={['image/jpg', 'image/png', 'application/pdf']}
                  onFileSelect={(file) => {
                    onChangeHandler(file, 'file', field);
                  }}
                  buttonVariant="SECONDARY"
                  defaultFile={getValues('message_values.file')}
                  preview
                />
              </div>
              {errors.message_values && (
                <p className="tw-text-xs tw-mt-4 tw-text-red-500">
                  {formState.errors.message_values?.message}
                </p>
              )}
            </div>
          )}
        />
      </div>
    </div>
  );
};
export default Step2QrPartial;
